import React from 'react'
import { BiShield } from 'react-icons/bi'

const SubmitButton = () => (
    <button 
        type="submit"
        className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
        <span className="flex items-center justify-center">
            Entrar no Sistema
            <BiShield className="ml-2 h-5 w-5" />
        </span>
    </button>
)

export default SubmitButton